var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.openModalDespacho &&
      _vm.idProcesso !== null &&
      _vm.acaoImpressao !== null
        ? _c("app-modal-despacho-presidente", {
            attrs: {
              idProcesso: _vm.idProcesso,
              acao: _vm.acaoImpressao,
              setor: "CHEFE_SETOR_DATGL",
              tipoProcesso: _vm.tipoProcesso,
              tituloModalDespacho: _vm.tituloModalDespacho
            },
            on: {
              closeModal: function($event) {
                _vm.openModalDespacho = false
              },
              finalizar: _vm.finalizarModalDespacho
            }
          })
        : _vm._e(),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: { titulo: "Documento", width: 1000, height: 800 },
              on: { closeModal: _vm.closeModal }
            },
            [
              _vm.isMaranhao
                ? _c("template", { slot: "body" }, [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _vm.responseDocumentos
                          ? _c(
                              "el-carousel",
                              {
                                staticClass: "body",
                                attrs: {
                                  "indicator-position": "outside",
                                  arrow: "always",
                                  loop: false,
                                  autoplay: false
                                },
                                on: { change: _vm.changeDocumentoVisualizar }
                              },
                              _vm._l(_vm.responseDocumentos, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "el-carousel-item",
                                  { key: index, staticClass: "body" },
                                  [
                                    _c("object", {
                                      attrs: {
                                        data:
                                          "data:application/pdf;base64," +
                                          item.base64,
                                        type: "application/pdf",
                                        width: "100%",
                                        height: "100%"
                                      }
                                    })
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "buttonExportPdf" },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.downloadPdf } },
                              [
                                _c("i", { staticClass: "fal fa-file-pdf" }),
                                _c("span", [_vm._v("  Exportar PDF")])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoTitulo,
              conteudo: _vm.conteudoModal,
              isProcesso: true,
              imprimir: _vm.imprimirTitulo
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _vm.showModalRetificarTitulo || _vm.showModalCancelarTitulo
        ? _c(
            "app-modal",
            {
              attrs: {
                titulo: _vm.showModalRetificarTitulo
                  ? "Solicitar Errata de Título"
                  : "Solicitar cancelamento de título"
              },
              on: { closeModal: _vm.closeModalRetificarTitulo }
            },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c("el-row", { staticClass: "margin-bottom" }, [
                    _c("span", { staticClass: "negrito" }, [
                      _vm._v(
                        "Assunto: " +
                          _vm._s(_vm.assunto) +
                          " - Processo nº " +
                          _vm._s(_vm.numeroProcesso)
                      )
                    ])
                  ]),
                  _c(
                    "validation-observer",
                    { ref: "validation", attrs: { tag: "div" } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    staticClass: "negrito",
                                    attrs: { label: _vm.motivo }
                                  }),
                                  _c("app-text-editor", {
                                    class: { erro: errors.length },
                                    attrs: { textEditable: true },
                                    model: {
                                      value: _vm.textoDespacho,
                                      callback: function($$v) {
                                        _vm.textoDespacho = $$v
                                      },
                                      expression: "textoDespacho"
                                    }
                                  }),
                                  _c("span", { staticClass: "help-erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2939948996
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "h4",
                    [
                      _vm._v("Anexos mensagem"),
                      _c("app-anexo", {
                        attrs: {
                          id: "upload-anexo-despacho",
                          exibirDownload: false,
                          files: _vm.anexos,
                          scope: "anexos",
                          tipoExibir: "ANEXO_ANALISE"
                        },
                        on: {
                          removeFile: _vm.removeFile,
                          uploadFile: _vm.uploadFile
                        },
                        model: {
                          value: _vm.anexos,
                          callback: function($$v) {
                            _vm.anexos = $$v
                          },
                          expression: "anexos"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "flex-between" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "secondary" },
                        on: { click: _vm.closeModalRetificarTitulo }
                      },
                      [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-times" }),
                          _c("span", [_vm._v("  Cancelar")])
                        ])
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.enviarSolicitacaoRetificacaoTitulo }
                      },
                      [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-share-square" }),
                          _c("span", [_vm._v("  Enviar")])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              showOs: true,
              showMunicipios: true,
              configuracaoFiltro: _vm.configuracaoFiltro,
              configuracaoFiltroSituacao: _vm.configuracaoFiltroSituacao,
              showFiltroTipoMultiplo: _vm.showFiltroTipoProcessoMultiplo,
              showFiltroDataEmissaoTitulo: _vm.showFiltroDataEmissaoTitulo,
              showFiltroDataChegada: !_vm.isMaranhao,
              showFiltroSetoresTituloCertidao:
                _vm.showFiltroSetoresTituloCertidao
            },
            on: { pesquisar: _vm.pesquisarTitulo, limpar: _vm.clearTitulo }
          }),
          _c(
            "div",
            { staticClass: "relative" },
            [
              _c("app-listagem", {
                attrs: {
                  "has-refresh-button": true,
                  showButtonOrdemServico: false,
                  showButtonAssinatura: false,
                  "has-expansivel": false,
                  "json-headers": _vm.colunas,
                  "json-data": _vm.items,
                  totalElements: _vm.totalElements,
                  pagina: _vm.filtro.pagina,
                  filtro: _vm.filtro,
                  showButtonExportarTitulos:
                    !_vm.isAmapa && !_vm.isMaranhao && !_vm.isBahia
                      ? true
                      : false,
                  textoButtonExportarTitulo: "Exportar Minutas",
                  caixa: "TITULO_CERTIDAO",
                  hasMultipleCheckbox: _vm.isMaranhao,
                  idsDisabledCheckbox: _vm.idsDisabledCheckbox
                },
                on: {
                  atualizarFiltro: _vm.atualizarFiltro,
                  updateListagem: _vm.refreshListagem,
                  changePage: _vm.interceptChangePage,
                  sort: _vm.interceptSort,
                  executar: _vm.executar,
                  selected: false,
                  exportarCsvFiltroAnalise: _vm.exportarCsvFiltroAnalise,
                  selectItem: _vm.selectItem,
                  exportarTitulos: _vm.EXPORTAR_TITULOS,
                  selectAll: _vm.selectAll
                }
              }),
              _vm.isMaranhao
                ? _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.disableExportarMinutasSelecionadas
                          },
                          on: { click: _vm.EXPORTAR_MINUTAS }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-download" }),
                            _vm._v(
                              "  " + _vm._s(_vm.textoButtonExportarMinutas)
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.disableExportarTodasMinutasSelecionadas
                          },
                          on: { click: _vm.EXPORTAR_TODAS_MINUTAS }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-download" }),
                            _vm._v(
                              "  " + _vm._s(_vm.textoButtonExportarTodasMinutas)
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-460e8871", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460e8871","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/CaixaTitulosECertidoesListagem.vue
// module id = null
// module chunks = 